module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/news/news.html
// module id = 575
// module chunks = 0